import $ from 'jquery';

export default function () {
  $(document).ready(() => {
    const keydownClass = 'c-key-down';
    // Using mousedown instead of mouseover, so that previously focused elements don't lose focus
    // ring on mouse move
    $('body').on('mousedown', () => {
      $('body').removeClass(keydownClass);
    });
    // keydown listener
    $('body').on('keydown', (e) => {
      const keyCode = e.keyCode || e.which;
      if (keyCode === 9) {
        $('body').addClass(keydownClass);
      }
    });
  });
}
